import { faEdit, faPhotoVideo } from "@fortawesome/free-solid-svg-icons";
import HtmlToReactParser from 'html-to-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Col, Row } from "@themesberg/react-bootstrap";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";
import { IMAGE_HOST } from "src/app/common/constants";
import { PropertyContext } from "src/app/contexts/PropertyContext";
import { routesPath } from "src/app/routes";
import NotFound from "../NotFound";
import MediaDataInput from "./property-input/MediaDataInput";
import './description.css';

const PropertyDetails = () => {
	const { id } = useParams();
	const [showImageUpdateModal, setShowImageUpdateModal] = useState(false);
	const { singlePropertyData, getSinglePropertyFromContext } = useContext(PropertyContext);

	useEffect(() => {
		if (id) {
			getSinglePropertyFromContext(id);
		}
	}, []);

	const renderDescription = (description) => {
		const parser = new HtmlToReactParser.Parser();
		return parser.parse(description);
	}

	return (
		<>
			{showImageUpdateModal && (
				<MediaDataInput
					{...{
						currentProperty: singlePropertyData,
						showImageUpdateModal,
						setShowImageUpdateModal,
					}}
				/>
			)}
			{singlePropertyData && (
				<>
					<div className="pt-4">
						<Link
							to={routesPath.AddProperty.path}
							state={singlePropertyData}
							className="btn btn-gray-800 mx-2"
						>
							<FontAwesomeIcon icon={faEdit} className="me-2" />
							Edit this property
						</Link>

						<span
							to={routesPath.AddProperty.path}
							state={singlePropertyData}
							className="btn btn-gray-800 mx-2"
							onClick={() => setShowImageUpdateModal(!showImageUpdateModal)}
						>
							<FontAwesomeIcon icon={faPhotoVideo} className="me-2" />
							Update property images
						</span>
					</div>
					<Row className="py-4">
						<Col xs={12} className="mb-4">
							<div className="bg-white rounded shadow p-3">
								<h2 className="mb-3 fw-bold display-3">
									{singlePropertyData.name}
								</h2>
								<hr />
								<Row xs={2} md={4} className="g-3">
									<Col className="w-100">
										<Card className="border-0 h-100">
											{singlePropertyData?.images?.head_image ? (
												<img
													src={
														singlePropertyData?.images?.head_image?.includes(
															"http"
														)
															? singlePropertyData?.images?.head_image
															: IMAGE_HOST +
															  singlePropertyData?.images?.head_image
													}
													alt="head_image"
												/>
											) : (
												<span className="text-center text-danger">
													Please upload images of this property
												</span>
											)}
										</Card>
									</Col>
									{singlePropertyData?.images?.side_images?.map((url, index) => (
										<Col>
											<Card className="border-0 h-100">
												<img
													src={
														url?.includes("http")
															? url
															: IMAGE_HOST + url
													}
													alt={"side_image" + index}
												/>
											</Card>
										</Col>
									))}
								</Row>
								<hr />
								<h4>Contact Info</h4>
								<Row xs={2} md={4} className="g-2 g-md-3">
									<Col>
										<Card className="rounded h-100 p-2">
											<h5 className="text-decoration-underline mb-3">
												Address
											</h5>
											<address>{singlePropertyData.address}</address>
										</Card>
									</Col>
									<Col>
										<Card className="rounded h-100 p-2">
											<h5 className="text-decoration-underline mb-3">
												Phone
											</h5>
											{singlePropertyData.phone?.map((number) => (
												<p className="mb-0">{number}</p>
											))}
										</Card>
									</Col>
									<Col>
										<Card className="rounded h-100 p-2">
											<h5 className="text-decoration-underline mb-3">
												Email
											</h5>
											<p className="mb-0">{singlePropertyData?.email}</p>
										</Card>
									</Col>
									<Col>
										<Card className="rounded h-100 p-2">
											<h5 className="text-decoration-underline mb-3">
												Website
											</h5>
											<p className="mb-0">{singlePropertyData?.website || 'N/A'}</p>
										</Card>
									</Col>
									<Col>
										<Card className="rounded h-100 p-2">
											<h5 className="text-decoration-underline mb-3">
												Social Info
											</h5>
											{singlePropertyData?.socials?.map((social) => (
												<p className="mb-0">
													<a href={social.link}>{social.name}</a>
												</p>
											)) || 'N/A'}
										</Card>
									</Col>
									<Col>
										<Card className="rounded h-100 p-2">
											<h5 className="text-decoration-underline mb-3">
												Other Info
											</h5>
											{singlePropertyData?.external_links?.map((ext) => (
												<p className="mb-0">
													<a href={ext.link}>{ext.name}</a>
												</p>
											)) || 'N/A'}
										</Card>
									</Col>
								</Row>
								<hr />
								<h4 className="mb-3">Description</h4>
								<div id="details-description">
									{ renderDescription(singlePropertyData.description) }
								</div>
								{/* <h4 className="mb-3">Amenities</h4>
								<div>
									<ul className="list-inline non-clickable-btn-list m-5">
										{singlePropertyData?.itins?.pet_policy == true && (
											<li className="list-inline-item">
												<span className="bg-gray-100 px-4 py-2 rounded-pill">
													Pet Policy
												</span>
											</li>
										)}
										{singlePropertyData?.itins?.refund_policy == true && (
											<li className="list-inline-item">
												<span className="bg-gray-100 px-4 py-2 rounded-pill">
													Refund Policy
												</span>
											</li>
										)}
										{singlePropertyData?.itins?.parking == true && (
											<li className="list-inline-item">
												<span className="bg-gray-100 px-4 py-2 rounded-pill">
													Parking
												</span>
											</li>
										)}
										{singlePropertyData?.itins?.wifi == true && (
											<li className="list-inline-item">
												<span className="bg-gray-100 px-4 py-2 rounded-pill">
													Wifi
												</span>
											</li>
										)}
										{singlePropertyData?.itins?.gym == true && (
											<li className="list-inline-item">
												<span className="bg-gray-100 px-4 py-2 rounded-pill">
													Gym
												</span>
											</li>
										)}
										{singlePropertyData?.itins?.pool == true && (
											<li className="list-inline-item">
												<span className="bg-gray-100 px-4 py-2 rounded-pill">
													Pool
												</span>
											</li>
										)}
										{singlePropertyData?.itins?.restaurant == true && (
											<li className="list-inline-item">
												<span className="bg-gray-100 px-4 py-2 rounded-pill">
													Restaurant
												</span>
											</li>
										)}
									</ul>
								</div>
								<hr />
								<h4 className="mb-3">Available Rooms</h4>
								<Row className="justify-content-center">
									<Col xs={10}>
										{singlePropertyData?.room_config?.map((room) => (
											<Row className="justify-content-center align-items-center border rounded py-2 mb-2">
												<Col className="text-center">{room?.name}</Col>
												<Col className="text-center">
													Adult: <span>{room?.adults}</span>
												</Col>
												<Col className="text-center">
													Child: <span>{room?.children}</span>
												</Col>
											</Row>
										))}
									</Col>
								</Row>
								<hr />
								<h4 className="mb-3">Available Payment methods</h4>
								<div>
									<ul className="list-inline non-clickable-btn-list mt-4 mb-4">
										{singlePropertyData?.payment_info?.map((info) => (
											<li className="list-inline-item">
												<span className="bg-gray-100 px-4 py-2 rounded-pill">
													{info.name}
												</span>
											</li>
										))}
									</ul>
								</div>
								<hr />
								<h4 className="mb-3">Things To Know</h4>
								<Row xs={2} md={4} className="g-2 g-md-3">
									<Col>
										<Card className="rounded h-100 p-2">
											<h5 className="text-decoration-underline mb-3">
												Check-in & Check-out
											</h5>
											<ul className="list-unstyled">
												<li>
													Check in - <b>{singlePropertyData?.itins?.check_in}</b>
												</li>
												<li>
													Check out -{" "}
													<b>{singlePropertyData?.itins?.check_out}</b>
												</li>
											</ul>
										</Card>
									</Col>

									<Col>
										<Card className="rounded h-100 p-2">
											<h5 className="text-decoration-underline mb-3">
												Others
											</h5>
											<p className="mb-0">
												Child max age:{" "}
												<b>{singlePropertyData?.itins?.child_max_age}</b>
											</p>
											<p className="mb-0">
												Room Prices:{" "}
												<b>{singlePropertyData?.price_low &&
													singlePropertyData?.price_low +
														"~" +
														singlePropertyData?.price_high}
												{singlePropertyData?.price &&
													singlePropertyData?.price}</b>
											</p>
											{singlePropertyData?.price_type && (
												<p className="mb-0">
													Price type: <b>{singlePropertyData?.price_type?.toUpperCase()}</b>
												</p>
											)}
										</Card>
									</Col>
								</Row> */}
							</div>
						</Col>
					</Row>
				</>
			)}
			{!singlePropertyData && <NotFound />}
		</>
	);
};

export default PropertyDetails;
